export default "__VITE_ASSET__BaZrU3k4__"